import { useContext } from 'react';
import { AuthContext } from '../context/AuthContext';

/**
 * Auth context'i kullanmak için hook
 * @returns {Object} Auth context değerleri
 */
export const useAuth = () => {
  const context = useContext(AuthContext);
  
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  
  return context;
}; 